let servicesTabs = document.querySelectorAll(".services__tab");
let servicesItems = document.querySelectorAll(".services__item");

if (servicesTabs.length && servicesItems.length) {
	servicesTabs.forEach((btn) => {
		btn.addEventListener("click", () => {
			let target = btn.dataset.target;
			let currentActive = document.querySelector(".services__tab--active");

			if (currentActive) {
				currentActive.classList.remove("services__tab--active");
			}

			btn.classList.add("services__tab--active");

			if (target) {
				servicesItems.forEach((item) => {
					if (item.dataset.target == target) {
						item.classList.remove("hidden");
					} else {
						item.classList.add("hidden");
					}
				});
			} else {
				servicesItems.forEach((item) => {
					item.classList.remove("hidden");
				});
			}
		});
	});
}

let servicesLink = document.querySelectorAll(".services__link");

function closeModal() {
	let modal = document.querySelector(".modalMD");
	let modalOverlay = document.querySelector(".modalMDOverlay");

	document.body.classList.remove("scrollOff");

	if (modal) {
		modal.remove();
	}
	if (modalOverlay) {
		modalOverlay.remove();
	}
}

function getDoctorTemplate(doctor) {
	return `
	<div class="doctorCard doctorsList__card">
		<a class="doctorCard__photoLink" href="${doctor.link}">
			<img class="doctorCard__photo" src="${doctor.photo}" alt="">
		</a>
		<div class="doctorCard__info">
			<div class="doctorCard__post">
				<svg width="16" height="16" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#Math)">
				<path fill-rule="evenodd" clip-rule="evenodd" d="M14.142 25.858C8.923 31.077 12.619 40 20 40c7.381 0 11.073-8.915 5.865-14.135C31.085 31.073 40 27.377 40 20c0-7.377-8.923-11.077-14.142-5.858C31.077 8.923 27.38 0 20 0S8.927 8.915 14.135 14.135C8.915 8.927 0 12.623 0 20c0 7.377 8.923 11.077 14.142 5.858Z" fill="url(#b)"></path>
				</g>
				<defs>
				<radialGradient id="b" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 -.12 19.885) scale(19.9954)">
				<stop stop-color="#E82F51" stop-opacity="0"></stop>
				<stop offset=".14" stop-color="#E82F51" stop-opacity=".22"></stop>
				<stop offset=".32" stop-color="#E82F51" stop-opacity=".5"></stop>
				<stop offset=".48" stop-color="#E82F51" stop-opacity=".71"></stop>
				<stop offset=".62" stop-color="#E82F51" stop-opacity=".87"></stop>
				<stop offset=".73" stop-color="#E82F51" stop-opacity=".96"></stop>
				<stop offset=".8" stop-color="#E82F51"></stop>
				<stop offset="1" stop-color="#E82F51"></stop>
				</radialGradient>
				<clipPath id="a">
				<path fill="#E82F51" d="M0 0h40v40H0z"></path>
				</clipPath>
				</defs>
				</svg>
				<span>${doctor.cabinet}</span>
			</div>
			<h2 class="doctorCard__name">
				<a href="${doctor.link}">${doctor.name}</a>
			</h2>
			<div class="doctorCard__spec">${doctor.spec}</div>
		</div>
	</div>
`;
}

if (servicesLink.length) {
	servicesLink.forEach((item) => {
		item.addEventListener("click", (evt) => {
			evt.preventDefault();

			let modal = document.createElement("div");
			modal.classList.add("modalMD");
			modal.classList.add("modalMD--absolute");

			let modalOverlay = document.createElement("div");
			modalOverlay.classList.add("modalMDOverlay");

			let modalCloseBtn = document.createElement("button");
			modalCloseBtn.setAttribute("type", "button");
			modalCloseBtn.setAttribute("aria-label", "Закрыть");
			modalCloseBtn.classList.add("modalMD__close");
			modalCloseBtn.innerHTML =
				'<svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#modalCLose)" fill="#fff"><circle opacity=".2" cx="20" cy="20" r="20"/><rect x="26.142" y="12" width="2" height="20" rx="1" transform="rotate(45 26.142 12)"/><rect x="12.142" y="13.414" width="2" height="20" rx="1" transform="rotate(-45 12.142 13.414)"/></g><defs><clipPath id="modalCLose"><path fill="#fff" d="M0 0h40v40H0z"/></clipPath></defs></svg>';

			modal.append(modalCloseBtn);

			let csrftoken = document.querySelector("input[name='csrfmiddlewaretoken']").value;

			fetch(item.href, { method: "POST", headers: { "X-CSRFToken": csrftoken } })
				.then((res) => res.json())
				.then((data) => {
					if (data.type == "child") {
						modal.classList.add("modalMD--kids");
					}

					if (data.heading) {
						let heading = document.createElement("h1");
						heading.classList.add("modalMD__heading");
						heading.innerText = data.heading;
						modal.append(heading);
					}

					if (data.content) {
						let text = document.createElement("div");
						text.classList.add("modalMD__text");
						text.innerHTML = data.content;
						modal.append(text);
					}

					if (data.doctors) {
						let doctors = document.createElement("div");
						doctors.classList.add("modalMD__doctors");

						let doctorsIntro = document.createElement("div");
						doctorsIntro.classList.add("modalMD__doctorsIntro");
						doctorsIntro.innerText = "Знакомьтесь подробнее с врачом на его странице";
						doctors.append(doctorsIntro);

						let doctorsList = document.createElement("div");
						doctorsList.classList.add("doctorsList");
						doctorsList.classList.add("modalMD__doctorsList");

						data.doctors.forEach((doctor) => {
							doctorsList.innerHTML = doctorsList.innerHTML + getDoctorTemplate(doctor);
						});

						doctors.append(doctorsList);

						modal.append(doctors);
					}
				})
				.catch((err) => {
					alert("Ошибка");
					closeModal();
				});

			document.body.append(modalOverlay);
			document.body.append(modal);
			document.body.classList.add("scrollOff");

			modalCloseBtn.addEventListener("click", closeModal);
			modalOverlay.addEventListener("click", closeModal);
		});
	});
}
